import script from "./ProductGroupInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductGroupInformation.vue?vue&type=script&setup=true&lang=ts"

import "./ProductGroupInformation.vue?vue&type=style&index=0&id=a4170b3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4170b3a"]])

export default __exports__